import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useBackfillIssueCounts } from '../../../hooks/api/backfills/useBackfillIssueCounts';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import LabeledCheckbox from '../../generic/Forms/LabeledCheckbox';

const IssueCountBackfillCard: VoidFunctionComponent = () => {
  const { onConfirm } = useDialogContext();
  const { mutate: backfillIssueCounts, isPending } = useBackfillIssueCounts();
  const [shouldOverwriteExisting, setShouldOverwrite] = useState(false);

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill Issue Count Snapshots',
      body: 'Are you sure you want to backfill issue count snapshots for this org?',
      onConfirm: async () => {
        backfillIssueCounts({ shouldOverwriteExisting });
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>
        Issue Count Snapshot
      </Card.Header>
      <Card.Content>
        <div>
          This will trigger a background job that backfills Issue Count Snapshots for this organization.
        </div>
        <LabeledCheckbox
          onChange={() => setShouldOverwrite(!shouldOverwriteExisting)}
          label="Override existing data?"
          isChecked={shouldOverwriteExisting}
        />
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Backfill
        </Button>
      </Card.Content>
    </Card>
  );
};

export default IssueCountBackfillCard;
